import { createContext, useContext, type ReactNode } from 'react'
import { openPrivacyPreferencesBar } from '@/utils/privacyPreferences'

type PrivacyPreferencesContextValue = {
  openPrivacyPreferences: () => void
}

const PrivacyPreferencesContext = createContext<PrivacyPreferencesContextValue | null>(null)

export const PrivacyPreferencesProvider = ({ children }: { children: ReactNode }) => (
  <PrivacyPreferencesContext.Provider
    value={{ openPrivacyPreferences: openPrivacyPreferencesBar }}
  >
    {children}
  </PrivacyPreferencesContext.Provider>
)

export const usePrivacyPreferencesModal = (): PrivacyPreferencesContextValue => {
  const context = useContext(PrivacyPreferencesContext)
  if (!context) {
    return { openPrivacyPreferences: () => undefined }
  }
  return context
}
